import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { getGetActingsQueryOptions } from '@area-restrita/api-client/endpoints/actings/actings.gen';

import { useQueryTable } from '@/hooks/useQueryTable';

import { columns } from './columns';
import BuslineActingView from './view';

interface IProps {
  buslineId: number;
}

const BuslineActing: React.FC<IProps> = ({ buslineId }) => {
  const navigate = useNavigate();

  const {
    query: { isLoading },
    table,
  } = useQueryTable({
    columns,
    getQueryOptions: (args) =>
      getGetActingsQueryOptions({ ...args, buslineId }),
  });

  return (
    <BuslineActingView
      isLoading={isLoading}
      table={table}
      onRowClick={({ id }) =>
        navigate({ to: '/actings/$actingId', params: { actingId: id } })
      }
    />
  );
};

export default BuslineActing;
